import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/graphic/play.svg'


const _withScopeId = n => (_pushScopeId("data-v-0c24e081"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "video-player--play",
  src: _imports_0,
  alt: "play icon"
}
const _hoisted_2 = {
  key: 1,
  class: "icon icon-users caseItem-shared"
}
const _hoisted_3 = {
  key: 2,
  class: "reshare-indicator"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-share" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "caseItem-author"
}
const _hoisted_7 = { class: "item-wrapper" }
const _hoisted_8 = { class: "text" }
const _hoisted_9 = {
  key: 0,
  class: "item-author-info"
}
const _hoisted_10 = {
  key: 0,
  class: "name"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 0,
  class: "checker checked"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-check" }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "checker unchecked"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_lazy_image = _resolveComponent("app-lazy-image")!
  const _component_app_question_pop_up = _resolveComponent("app-question-pop-up")!
  const _component_mixed_media_pop_up = _resolveComponent("mixed-media-pop-up")!
  const _component_app_rename_file = _resolveComponent("app-rename-file")!

  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.viewPhoto(_ctx.photo))),
    class: _normalizeClass([{'case-item-column': _ctx.columnView}, "caseItem"])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["caseItem-photo", {'case-item-grid': (_ctx.driveStore.photoViewLayout === _ctx.PHOTO_VIEW_LAYOUT.GRID) && !_ctx.columnView && !_ctx.blockGrid}])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["photo-box", {'photo-wrapper--grid': (_ctx.driveStore.photoViewLayout === _ctx.PHOTO_VIEW_LAYOUT.GRID) && !_ctx.columnView && !_ctx.blockGrid}])
      }, [
        _createVNode(_component_app_lazy_image, { url: _ctx.photoUrl }, null, 8, ["url"]),
        (_ctx.photo.type === 'VIDEO')
          ? (_openBlock(), _createElementBlock("img", _hoisted_1))
          : _createCommentVNode("", true),
        (!!_ctx.photo.share && !_ctx.authorPhotoUrl)
          ? (_openBlock(), _createElementBlock("i", _hoisted_2))
          : _createCommentVNode("", true),
        (_ctx.reshareAllowed)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
          : _createCommentVNode("", true)
      ], 2)
    ], 2),
    (_ctx.showTitle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h6", _hoisted_8, _toDisplayString(_ctx.photo.name), 1),
            (_ctx.isNetwork)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_ctx.columnView && !_ctx.mainStore.isMobile)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.authorName), 1))
                    : _createCommentVNode("", true),
                  (_ctx.authorPhotoUrl)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        class: "photo",
                        src: _ctx.authorPhotoUrl
                      }, null, 8, _hoisted_11))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.showMenuDots)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.isMediaSettingsPopUp = true), ["prevent","stop"])),
                class: "icon icon-dots photo-item-option"
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.selector)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.photo.selected || _ctx.isSelectedFromParent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
            : (_openBlock(), _createElementBlock("div", _hoisted_15))
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.isQuestionPopUp)
      ? (_openBlock(), _createBlock(_component_app_question_pop_up, {
          key: 2,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isQuestionPopUp = false)),
          onDelete: _ctx.deletePhoto
        }, null, 8, ["onDelete"]))
      : _createCommentVNode("", true),
    (_ctx.isMediaSettingsPopUp)
      ? (_openBlock(), _createBlock(_component_mixed_media_pop_up, {
          key: 3,
          file: _ctx.photo,
          onClosePopUp: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isMediaSettingsPopUp = false)),
          onOpenFileRename: _cache[3] || (_cache[3] = ($event: any) => (_ctx.fileRenamePopUp = true))
        }, null, 8, ["file"]))
      : _createCommentVNode("", true),
    (_ctx.fileRenamePopUp)
      ? (_openBlock(), _createBlock(_component_app_rename_file, {
          key: 4,
          file: _ctx.photo,
          "mount-error-info": _ctx.renameMountErrorInfo,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.fileRenamePopUp = false)),
          onOpen: _ctx.openRenamePopUp,
          onClearMountErrorInfo: _cache[5] || (_cache[5] = ($event: any) => (_ctx.renameMountErrorInfo = undefined))
        }, null, 8, ["file", "mount-error-info", "onOpen"]))
      : _createCommentVNode("", true)
  ], 2))
}